export const iconFontAwesomeTransportationMound = (
	<i className="fa-solid fa-mound"></i>
);
